import React, { Component, Fragment } from "react";
import CreateModel from "./CreateModel";
import List from "./List";
import Footer from "../../utilities/Footer";
import AppContext from "../../../contexts/AppContext";
import NoData from "../../utilities/NoData";
import LoadingData from "../../utilities/LoadingData";

import {
    records,
    record,
    remove,
    search,
    update,
    create,
    filter
} from "../../../services/badge";
import Header from "../Header";

class Badges extends Component {
    state = {
        items: [],
        meta: {},
        query: "",
        filter: false,
        search: false,
        create: false,
        loading: true,
        tableCount: "hide",
        filterItem: "all"
    };

    delete = id => {
        return remove(id).then(response => {
            let temp = this.state.items;
            for (var i in temp) {
                if (temp[i].id === id) {
                    temp.splice(i, 1);
                    this.setState({ items: temp });
                }
            }
        });
    };

    update = (id, item) => {
        return update(id, item).then(response => {
            let temp = this.state.items;
            for (var i in temp) {
                if (temp[i].id === id) {
                    temp[i] = response.data;
                    this.setState({ items: temp });
                }
            }
        });
    };

    create = item => {
        return create(item).then(response => {
            let temp = this.state.items;
            temp.unshift(response.data);
            this.setState({ items: temp });
        });
    };

    toggleCreate = () => {
        this.setState({ create: this.state.create === true ? false : true });
    };

    toggleTableCount = () => {
        this.setState({
            tableCount: this.state.tableCount === "hide" ? "show" : "hide"
        });
    };
    record = id => {
        return record(id);
    };
    onQueryChange = field => {
        this.setState({ query: field.target.value });
    };
    search = query => {
        this.setState({ loading: true });
        search(query).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                search: true,
                query: query,
                loading: false
            });
        });
    };

    filter = item => {
        this.setState({ loading: true });
        filter(item).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                filter: true,
                loading: false,
                filterItem: item
            });
        });
    };
    clear = () => {
        this.setState({ loading: true });
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    search: false,
                    filter: false,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };

    componentDidMount() {
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }
    changePage = page => {
        if (this.state.search === true) {
            search(this.state.query, page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        } else {
            records(page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        }
    };
    submitSearch = e => {
        e.preventDefault();
        if (this.state.query.length >= 1) {
            this.search(this.state.query);
        } else {
            this.clear();
        }
    };

    render() {
        return (
            <Fragment>
                <Header></Header>
                <div className="main-content mt-6">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="header">
                                    <div className="header-body">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h1 className="header-title">
                                                    Badges
                                                </h1>
                                                <h6 className="header-pretitle">
                                                    Overview all available
                                                    Badges
                                                </h6>
                                            </div>
                                            <div className="col-auto">
                                                <button
                                                    onClick={this.toggleCreate}
                                                    className="btn btn-primary"
                                                >
                                                    New record
                                                </button>
                                            </div>
                                        </div>
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <ul className="nav nav-tabs nav-overflow header-tabs">
                                                    <li className="nav-item">
                                                        <button
                                                            onClick={() =>
                                                                this.filter(
                                                                    "all"
                                                                )
                                                            }
                                                            className={
                                                                this.state
                                                                    .filterItem ===
                                                                "all"
                                                                    ? `nav-link active`
                                                                    : `nav-link `
                                                            }
                                                        >
                                                            All{" "}
                                                            <span className="badge badge-pill badge-soft-secondary">
                                                                {
                                                                    this.state
                                                                        .meta
                                                                        .total
                                                                }
                                                            </span>
                                                        </button>
                                                    </li>
                                                    <li className="nav-item">
                                                        <button
                                                            onClick={() =>
                                                                this.filter(
                                                                    "auto"
                                                                )
                                                            }
                                                            className={
                                                                this.state
                                                                    .filterItem ===
                                                                "auto"
                                                                    ? `nav-link active`
                                                                    : `nav-link`
                                                            }
                                                        >
                                                            Auto{" "}
                                                            <span className="badge badge-pill badge-soft-secondary">
                                                                {
                                                                    this.state
                                                                        .meta
                                                                        .auto
                                                                }
                                                            </span>
                                                        </button>
                                                    </li>
                                                    <li className="nav-item">
                                                        <button
                                                            onClick={() =>
                                                                this.filter(
                                                                    "skills"
                                                                )
                                                            }
                                                            className={
                                                                this.state
                                                                    .filterItem ===
                                                                "skills"
                                                                    ? `nav-link active`
                                                                    : `nav-link`
                                                            }
                                                        >
                                                            Skills{" "}
                                                            <span className="badge badge-pill badge-soft-secondary">
                                                                {
                                                                    this.state
                                                                        .meta
                                                                        .skills
                                                                }
                                                            </span>
                                                        </button>
                                                    </li>
                                                    <li className="nav-item">
                                                        <button
                                                            onClick={() =>
                                                                this.filter(
                                                                    "performance"
                                                                )
                                                            }
                                                            className={
                                                                this.state
                                                                    .filterItem ===
                                                                "performance"
                                                                    ? `nav-link active`
                                                                    : `nav-link`
                                                            }
                                                        >
                                                            Performance{" "}
                                                            <span className="badge badge-pill badge-soft-secondary">
                                                                {
                                                                    this.state
                                                                        .meta
                                                                        .performance
                                                                }
                                                            </span>
                                                        </button>
                                                    </li>
                                                    <li className="nav-item">
                                                        <button
                                                            onClick={() =>
                                                                this.filter(
                                                                    "experience"
                                                                )
                                                            }
                                                            className={
                                                                this.state
                                                                    .filterItem ===
                                                                "experience"
                                                                    ? `nav-link active`
                                                                    : `nav-link`
                                                            }
                                                        >
                                                            Experience{" "}
                                                            <span className="badge badge-pill badge-soft-secondary">
                                                                {
                                                                    this.state
                                                                        .meta
                                                                        .experience
                                                                }
                                                            </span>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card">
                                    <div className="card-header">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <form
                                                    onSubmit={this.submitSearch}
                                                    className="row align-items-center"
                                                >
                                                    <div className="col-auto pr-0">
                                                        <span className="fe fe-search text-muted"></span>
                                                    </div>
                                                    <div className="col">
                                                        <input
                                                            onChange={this.onQueryChange.bind(
                                                                this
                                                            )}
                                                            value={
                                                                this.state.query
                                                            }
                                                            type="search"
                                                            className="form-control form-control-flush search"
                                                            placeholder="Search"
                                                        ></input>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        {this.state.loading === true ? (
                                            <LoadingData></LoadingData>
                                        ) : this.state.items.length >= 1 ? (
                                            <table className="table table-sm table-nowrap card-table">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <div className="custom-control custom-checkbox table-checkbox">
                                                                #
                                                            </div>
                                                        </th>
                                                        <th>Name</th>
                                                        <th>Type</th>
                                                        <th className="large">
                                                            Description
                                                        </th>
                                                        <th>Date</th>
                                                        <th>Image</th>
                                                        <th className="Options">
                                                            Options
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="list">
                                                    {this.state.items.map(
                                                        (item, index) => {
                                                            return (
                                                                <List
                                                                    getItem={
                                                                        this
                                                                            .record
                                                                    }
                                                                    update={
                                                                        this
                                                                            .update
                                                                    }
                                                                    delete={
                                                                        this
                                                                            .delete
                                                                    }
                                                                    item={item}
                                                                    index={
                                                                        index
                                                                    }
                                                                    key={index}
                                                                ></List>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <NoData></NoData>
                                        )}
                                    </div>
                                    <div>
                                        <Footer
                                            changePage={this.changePage}
                                            totalPages={this.state.meta.pages}
                                            curentPage={this.state.meta.page}
                                        ></Footer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.create === true ? (
                        <CreateModel
                            create={this.create}
                            hideCreate={this.toggleCreate}
                        ></CreateModel>
                    ) : null}
                </div>
            </Fragment>
        );
    }
}
Badges.contextType = AppContext;
export default Badges;



// WEBPACK FOOTER //
// ./src/components/admin/badges/Badges.js